// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"473":"9f61b6a4","845":"915e00e8"}[chunkId] + ".chunk.js";
};